export default __webpack_public_path__ + "static/media/generic.9c403546.svg";